import React from "react";
import banner from "../assets/banner3.jpg";

export default function NdomanoLogistics() {
  return (
    <div className="MainBodySection py-5">
      <div className="container">
        <div className="row align-items-center mb-4">
          <div className="col-md-6 text-center">
            <img src={banner} alt="Ndomano Logistics" className="img-fluid rounded" style={{maxHeight: '320px', objectFit: 'cover'}} />
          </div>
          <div className="col-md-6">
            <h2 className="main-section-title">Ndomano Logistics (T) LTD</h2>
            <p className="text-muted">
              Ndomano Logistics provides reliable cargo transport and digital tracking solutions. Our services support businesses with timely, secure, and traceable movement of goods across Tanzania and the region, backed by an experienced operations team.
            </p>
            <p className="text-muted">
              We combine modern fleet management practices with customer-centric tracking portals to give shippers real-time visibility and predictable delivery performance, helping supply chains run smoother.
            </p>
            <div className="my-3">
              <a className="btn btn-primary" href="https://ndomanologistics.com" target="_blank" rel="noreferrer">Visit Ndomano Logistics</a>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}
